// Sinthu Nathan, portfolio content
// All copy in one place so it's easy to iterate and swap.

export const ASSETS = {
  portrait:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/utcafojq_image.png",
  cvPdf: "/downloads/Sinthu-Nathan-CV.pdf?v=20261011",
  cvOriginal:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/htsbzhju_Profile.pdf",
  sipServe: [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/1lwk1szr_IMG_4166.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/w29k38qr_IMG_4165.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/lxi9jnwa_IMG_4167.webp",
  ],
  linkedinScreens: [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/v9qbcxtz_Sk%C3%A6rmbillede%202026-09-18%20kl.%2002.11.07.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/ddj328sh_Sk%C3%A6rmbillede%202026-09-18%20kl.%2002.11.21.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/586iw7x6_Sk%C3%A6rmbillede%202026-09-18%20kl.%2002.11.32.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/bvf8o5oz_Sk%C3%A6rmbillede%202026-09-18%20kl.%2002.11.41.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/ycvtd82n_Sk%C3%A6rmbillede%202026-09-18%20kl.%2002.11.47.webp",
  ],
  factory: "/artifacts/ur-customer-journey-map.jpg",
  dashboard: "/artifacts/ur-cx-dashboard.jpg",
  urArtifacts: {
    journeyMap: "/artifacts/ur-customer-journey-map.jpg",
    lifecycleLoop: "/artifacts/ur-customer-lifecycle-loop.jpg",
    archetypes: "/artifacts/ur-behavioural-archetypes.jpg",
    cxDashboard: "/artifacts/ur-cx-dashboard.jpg",
  },
};

export const PROFILE = {
  name: "Sinthu Nathan",
  positioning: "Customer Insights & Growth Researcher, turning customer evidence into commercial decisions",
  title: "Customer Insights & Growth Researcher",
  location: "Odense · Denmark",
  email: "sinthu_8700@hotmail.com",
  phone: "+45 28 96 75 73",
  linkedin: "https://www.linkedin.com/in/sinthunathan",
  domain: "sinthunathan.com",
  languages: [
    { name: "Danish", level: "native" },
    { name: "English", level: "fluent" },
    { name: "French", level: "proficient" },
  ],
  credibility: [
    "Competitive benchmarking used by the CEO for strategy",
    "Global discovery on 3 continents → segment roadmap",
    "Growth loop built & measured: NPS +66, reach +1,186%",
    "Research system built from scratch, with AI",
  ],
  about: `I am a customer insights researcher with a UX background. For four years at Universal Robots I worked with product managers, engineers and QA on discovery in the food and pharma industries: interviewing operators and plant managers in Asia, Europe and the US, mapping customer journeys, and building the competitor benchmarking model our leadership used for pricing and strategy. Since 2026 I sit on the board of Tennis Club Odense, where I built our event app and surveys myself with AI and use the data to decide what we do next. I like research that ends in a decision, and I like being the one who follows it through.`,
};

export const BENEFITS = {
  about:
    "An owner of customer insights who turns continuous data into growth decisions.",
  roleFit:
    "Every line of the brief, already done once, with the result to show for it.",
  ai:
    "AI handles the volume; I handle the judgement. Insights land while the decision is still open.",
  projects:
    "A benchmark leadership decides with, a growth loop measured on real users, and segment discovery that shaped a roadmap.",
  personality:
    "A researcher who wins the room, sees the pattern and tells the story, measured by Gallup, not self-described.",
  toolkit:
    "No ramp-up on tools, research, product and AI stack already in daily use.",
  experience:
    "Five years of research across pricing, product and growth stakeholders, method, tools and commercial fluency.",
  testimonials:
    "Colleagues describe the same thing: insights with a tangible impact on decision-making.",
};

export const TOOLKIT = [
  {
    group: "Research & insight",
    items: ["UserTesting", "UserZoom", "EnjoyHQ", "SurveyMonkey", "SurveyXact", "Power BI"],
  },
  {
    group: "Product & collaboration",
    items: ["Jira", "HubSpot", "Salesforce", "Microsoft Dynamics 365", "Miro", "Microsoft 365", "Teams", "SharePoint", "PowerPoint"],
  },
  {
    group: "Design & prototyping",
    items: ["Figma", "Adobe XD", "Photoshop", "Illustrator", "InDesign", "Premiere Pro", "After Effects", "Acrobat"],
  },
  {
    group: "AI & productivity",
    items: ["Claude", "ChatGPT", "Microsoft Copilot"],
  },
];

export const STRENGTHS = [
  "Business minded",
  "Analytical thinking",
  "System building",
  "Customer experience",
  "Research operations",
  "Visionary and practical",
  "Customer-centric innovation",
];

export const PRINCIPLES = [
  { title: "Reduce uncertainty", body: "Replace assumptions with evidence." },
  { title: "Connect insights to decisions", body: "Research ends in a decision, not a deck." },
  { title: "Build systems, not isolated studies", body: "Continuous data compounds over time." },
  { title: "AI for volume, human for judgement", body: "Hands-on with AI, human in the loop." },
];

export const THEME_DESCRIPTIONS = {
  "Woo": "People who are especially talented in the Woo theme love the challenge of meeting new people and winning them over. They derive satisfaction from breaking the ice and making a connection with another person.",
  "Strategic": "People who are especially talented in the Strategic theme create alternative ways to proceed. Faced with any given scenario, they can quickly spot the relevant patterns and issues.",
  "Significance": "People who are especially talented in the Significance theme want to be very important in the eyes of others. They are independent and want to be recognized.",
  "Communication": "People who are especially talented in the Communication theme generally find it easy to put their thoughts into words. They are good conversationalists and presenters.",
  "Adaptability": "People who are especially talented in the Adaptability theme prefer to “go with the flow.” They tend to be “now” people who take things as they come and discover the future one day at a time.",
  "Activator": "People who are especially talented in the Activator theme can make things happen by turning thoughts into action. They are often impatient.",
  "Positivity": "People who are especially talented in the Positivity theme have an enthusiasm that is contagious. They are upbeat and can get others excited about what they are going to do.",
  "Empathy": "People who are especially talented in the Empathy theme can sense the feelings of other people by imagining themselves in others’ lives or others’ situations.",
  "Individualization": "People who are especially talented in the Individualization theme are intrigued with the unique qualities of each person. They have a gift for figuring out how people who are different can work together productively.",
  "Input": "People who are especially talented in the Input theme have a craving to know more. Often they like to collect and archive all kinds of information.",
  "Command": "People who are especially talented in the Command theme have presence. They can take control of a situation and make decisions.",
  "Restorative": "People who are especially talented in the Restorative theme are adept at dealing with problems. They are good at figuring out what is wrong and resolving it.",
  "Self-Assurance": "People who are especially talented in the Self-Assurance theme feel confident in their ability to manage their own lives. They possess an inner compass that gives them confidence that their decisions are right.",
  "Developer": "People who are especially talented in the Developer theme recognize and cultivate the potential in others. They spot the signs of each small improvement and derive satisfaction from these improvements.",
  "Arranger": "People who are especially talented in the Arranger theme can organize, but they also have a flexibility that complements this ability. They like to figure out how all of the pieces and resources can be arranged for maximum productivity.",
  "Ideation": "People who are especially talented in the Ideation theme are fascinated by ideas. They are able to find connections between seemingly disparate phenomena.",
  "Analytical": "People who are especially talented in the Analytical theme search for reasons and causes. They have the ability to think about all the factors that might affect a situation.",
  "Competition": "People who are especially talented in the Competition theme measure their progress against the performance of others. They strive to win first place and revel in contests.",
  "Context": "People who are especially talented in the Context theme enjoy thinking about the past. They understand the present by researching its history.",
  "Focus": "People who are especially talented in the Focus theme can take a direction, follow through, and make the corrections necessary to stay on track. They prioritize, then act.",
  "Includer": "People who are especially talented in the Includer theme are accepting of others. They show awareness of those who feel left out, and make an effort to include them.",
  "Learner": "People who are especially talented in the Learner theme have a great desire to learn and want to continuously improve. In particular, the process of learning, rather than the outcome, excites them.",
  "Achiever": "People who are especially talented in the Achiever theme have a great deal of stamina and work hard. They take great satisfaction from being busy and productive.",
  "Belief": "People who are especially talented in the Belief theme have certain core values that are unchanging. Out of these values emerges a defined purpose for their life.",
  "Futuristic": "People who are especially talented in the Futuristic theme are inspired by the future and what could be. They inspire others with their visions of the future.",
  "Intellection": "People who are especially talented in the Intellection theme are characterized by their intellectual activity. They are introspective and appreciate intellectual discussions.",
  "Consistency": "People who are especially talented in the Consistency theme are keenly aware of the need to treat people the same. They try to treat everyone in the world with consistency by setting up clear rules and adhering to them.",
  "Relator": "People who are especially talented in the Relator theme enjoy close relationships with others. They find deep satisfaction in working hard with friends to achieve a goal.",
  "Responsibility": "People who are especially talented in the Responsibility theme take psychological ownership of what they say they will do. They are committed to stable values such as honesty and loyalty.",
  "Deliberative": "People who are especially talented in the Deliberative theme are best described by the serious care they take in making decisions or choices. They anticipate the obstacles.",
  "Connectedness": "People who are especially talented in the Connectedness theme have faith in the links between all things. They believe there are few coincidences and that almost every event has a reason.",
  "Discipline": "People who are especially talented in the Discipline theme enjoy routine and structure. Their world is best described by the order they create.",
  "Harmony": "People who are especially talented in the Harmony theme look for consensus. They don’t enjoy conflict; rather, they seek areas of agreement.",
  "Maximizer": "People who are especially talented in the Maximizer theme focus on strengths as a way to stimulate personal and group excellence. They seek to transform something strong into something superb. COPYRIGHT STANDARDS This document contains proprietary research, copyrighted and trademarked materials of Gallup, Inc. Accordingly, international and domestic laws and penalties guaranteeing patent, copyright, trademark and trade secret protection safeguard the ideas, concepts and recommendations related within this document. The materials contained in this document and/or the document itself may be downloaded and/or copied provided that all copies retain the copyright, trademark and any other proprietary notices contained on the materials and/or document. No changes may be made to this document without the express written permission of Gallup, Inc. Any reference whatsoever to this document, in whole or in part, on any webpage must provide a link back to the original document in its entirety. Except as expressly provided herein, the transmission of this material shall not be construed to grant a license of any type under any patents, copyright or trademarks owned or controlled by Gallup, Inc. Gallup® , CliftonStrengths® , Clifton StrengthsFinder® , StrengthsFinder® and each of the 34 strengths theme names are trademarks of Gallup, Inc. All rights reserved. All other trademarks and copyrights are the property of their respective owners. 98292083 (Sinthu Nathan) StrengthsFinder® | Copyright © 2000, 2006-2012 Gallup, Inc. All rights reserved. 6"
};

export const STRENGTHS_PROFILE = {
  completed: "November 2024",
  reportUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_profile-forge-246/artifacts/hot3rgwr_Nathan-Sinthu-ALL_34.pdf",
  summary:
    "Influencing and Relationship Building carry the top ten, anchored by Strategic and Input: win the room, read the people, spot the pattern, then tell the story.",
  domains: {
    influencing: {
      label: "Influencing",
      color: "#9a7218",
      themes: ["Activator", "Command", "Communication", "Competition", "Maximizer", "Self-Assurance", "Significance", "Woo"],
    },
    relationship: {
      label: "Relationship building",
      color: "#d9a92e",
      themes: ["Adaptability", "Connectedness", "Developer", "Empathy", "Harmony", "Includer", "Individualization", "Positivity", "Relator"],
    },
    strategic: {
      label: "Strategic thinking",
      color: "#14352a",
      themes: ["Analytical", "Context", "Futuristic", "Ideation", "Input", "Intellection", "Learner", "Strategic"],
    },
    executing: {
      label: "Executing",
      color: "#86928a",
      themes: ["Achiever", "Arranger", "Belief", "Consistency", "Deliberative", "Discipline", "Focus", "Responsibility", "Restorative"],
    },
  },
  top5: [
    {
      name: "Woo",
      gallup: "Loves the challenge of meeting new people and winning them over, strangers are energising, not intimidating.",
      atWork: "Meets customers in person and online, on factory floors and at fairs, and builds rapport in minutes.",
      brief: "Meet with customers, both in person and online",
    },
    {
      name: "Strategic",
      gallup: "Sorts through the clutter and finds the best route; sees patterns where others see complexity.",
      atWork: "Turns 300+ data points into one benchmarking model leadership can decide with.",
      brief: "Run global discovery research to define customer needs, pain points, and opportunities",
    },
    {
      name: "Significance",
      gallup: "Wants the work to matter and be recognised, credible, professional, pulled toward the exceptional.",
      atWork: "Owns the insight end to end and takes it all the way to the CEO.",
      brief: "Owner of customer insights, from product manager to CEO",
    },
    {
      name: "Communication",
      gallup: "Finds it easy to put thoughts into words; turns dry data into stories that survive.",
      atWork: "Executive share-outs, journey maps and dashboards people actually act on.",
      brief: "Build customer journey maps and service blueprints",
    },
    {
      name: "Adaptability",
      gallup: "Lives in the moment and responds willingly to what the day demands.",
      atWork: "Data-driven and iterative by nature, thrives when the plan changes.",
      brief: "Build the research system from scratch, with the use of AI, data-driven and iterative",
    },
  ],
  all34: [
    "Woo", "Strategic", "Significance", "Communication", "Adaptability",
    "Activator", "Positivity", "Empathy", "Individualization", "Input",
    "Command", "Restorative", "Self-Assurance", "Developer", "Arranger",
    "Ideation", "Analytical", "Competition", "Context", "Focus",
    "Includer", "Learner", "Achiever", "Belief", "Futuristic",
    "Intellection", "Consistency", "Relator", "Responsibility", "Deliberative",
    "Connectedness", "Discipline", "Harmony", "Maximizer",
  ],
};

export const DELIVERABLES = [
  {
    group: "Market & User Research",
    items: [
      { icon: "Search", title: "Market and User Research", body: "75+ usability tests and surveys accumulated at Universal Robots, across markets and segments, from operators on the factory floor to non-customers.", to: "/case-studies/food-industry-ur", proof: "Food industry case, one example" },
      { icon: "Lightbulb", title: "Actionable Customer Insights", body: "100+ documented customer insights on needs, pain points and opportunities, turned into strategic direction from product manager to CEO.", to: "/case-studies/food-industry-ur", proof: "Segment roadmap, food industry" },
      { icon: "Map", title: "Customer Journey Maps", body: "End-to-end journey maps for pharma and food & beverage, and the robot unboxing journey.", to: "/case-studies/food-industry-ur", proof: "UR journey map artefact" },
      { icon: "Users", title: "Behavioural Archetypes & Personas", body: "Research-driven archetypes with requirements per target group, anchored through several internal workshops I facilitated.", to: "/case-studies/food-industry-ur", proof: "UR archetypes artefact" },
    ],
  },
  {
    group: "Commercial & Business Analysis",
    items: [
      { icon: "BarChart3", title: "Competitive Benchmarking", body: "A customisable Power BI visualisation of our value proposition against key competitors, answering strategic, commercial and product-development questions from one model.", to: "/case-studies/power-bi-benchmarking", proof: "Power BI case" },
      { icon: "Target", title: "Pricing & Positioning Input", body: "Regular testing with non-customers, reported to Service on a fixed cadence; word-association tests for several departments showed what our external communication actually signals.", to: "/case-studies/power-bi-benchmarking", proof: "Power BI case, Pricing Director" },
      { icon: "TrendingUp", title: "Growth Metrics & KPIs", body: "NPS/CSAT loops and product analytics. A CSAT and transparent webinars at UR Academy lifted engagement and changed the Academy mindset; at Tennis Club Odense, NPS +66.", to: "/case-studies/sip-and-serve", proof: "Sip & Serve case, NPS +66" },
    ],
  },
];

export const ROLE_FIT = [
  {
    ask: "Run global discovery research to define customer needs, pain points, and opportunities globally",
    proof: "Needs, pain points and opportunities, plant visits and 200+ interviews on three continents.",
    to: "/case-studies/food-industry-ur",
    cta: "Food-industry case",
  },
  {
    ask: "Build the research system from scratch, with the use of AI",
    proof: "Sip & Serve TCO: surveys, live NPS/CSAT and analytics, built solo with AI, run on real members.",
    to: "/case-studies/sip-and-serve",
    cta: "Sip & Serve case",
  },
  {
    ask: "Build customer journey maps and service blueprints",
    proof: "End-to-end journey maps and cross-functional journey workshops at UR, artefacts inside.",
    to: "/case-studies/food-industry-ur",
    cta: "See the artefacts",
  },
  {
    ask: "Build archetypes and personas, and define requirements for different target groups",
    proof: "Behavioural archetypes and requirements per target group, one set per hygienic zone.",
    to: "/case-studies/food-industry-ur",
    cta: "Zone requirements",
  },
  {
    ask: "Work alongside the UX Architect and UX Designer to validate assumptions and test ideas",
    proof: "Assumptions validated with the UR design team through usability and observational testing.",
    to: "#projects",
    cta: "Also worth mentioning",
  },
  {
    ask: "Use and set up analytics in digital products for continuous improvement",
    proof: "Power BI benchmarking for the CEO, live NPS/CSAT in the app, and this site's own funnel.",
    to: "/analytics",
    cta: "Live analytics",
  },
  {
    ask: "Meet with customers, both in person and online",
    proof: "Factory floors, industry fairs and remote sessions, three languages, three continents.",
    to: "#about",
    cta: "Three languages",
  },
  {
    ask: "Build the community and feedback loop",
    proof: "Sold-out event, reach +1,186%, team 4 → 15 · and a member CSAT loop that sets the next agenda.",
    to: "/case-studies/sip-and-serve",
    cta: "Community metrics",
  },
  {
    ask: "Prepare for beta testing, collect feedback, and generate insights",
    proof: "Pre/post surveys in the beta → NPS +66 → the brief for the next edition. 63% wanted more matches.",
    to: "/case-studies/sip-and-serve",
    cta: "Survey loop",
  },
];

export const GUIDE = {
  name: "Sinthusiast",
  tagline: "Guide to Sinthu's portfolio",
  welcome:
    "Hi, I'm Sinthusiast, the guide on Sinthu's portfolio. I can take you through it in 90 seconds, or answer your questions directly.",
  greeting:
    "Ask me anything about Sinthu's work, or pick a shortcut below.",
};

export const TOUR_STEPS = [
  {
    id: "hero",
    title: "Meet Sinthu",
    text: "Customer Insights & Growth Researcher from Odense. Four years of global discovery research at Universal Robots, and a research system she built from scratch, with AI.",
  },
  {
    id: "journey",
    title: "Your journey map",
    text: "The whole portfolio, laid out as the artefact she builds for a living, a customer journey map. Click any stage for the short version. The curve is the intended visitor mood; your votes draw the real one.",
  },
  {
    id: "about",
    title: "Research meets business",
    text: "Owner of customer insights, not a producer of decks. She defines needs, pain points and opportunities and turns continuous data into decisions, data-driven, iterative, human in the loop. Her work was presented from product manager to CEO.",
  },
  {
    id: "experience",
    title: "The track record",
    text: "Five years of research practice: Universal Robots 2021 to 25, then board member at Tennis Club Odense running the member CSAT survey. Power BI certified, all-A grades in Digital Concept Development.",
  },
  {
    id: "personality",
    title: "Who she is, measured",
    text: "Gallup CliftonStrengths 34: Woo, Strategic, Significance, Communication, Adaptability. She leads with Influencing, wins the room, spots the pattern, tells the story. Measured by Gallup, not self-described.",
  },
  {
    id: "projects",
    title: "Three case studies",
    text: "Factory-floor discovery in the food industry, a shipped PWA with a sold-out event and an NPS of +66, and a Power BI dashboard the CEO was 'tremendously impressed' by. She built the app solo, with AI as copilot.",
  },
  {
    id: "ai-methodology",
    title: "Methodology",
    text: "Preparing fieldwork, interviews, analysis, reporting, tracking. Her end-to-end research method, with AI as one part of the work and stakeholder management across every stage.",
  },
  {
    id: "live-stats",
    title: "It measures itself",
    text: "Look, this portfolio tracks its own engagement: visits, scroll depth, what people ask me. A researcher who instruments her own work.",
  },
  {
    id: "testimonials",
    title: "In their words",
    text: "Nine verbatim LinkedIn recommendations. Pricing Director Piotr M. Klima: 'This is what outstanding researchers, analysts and strategists do!'",
  },
  {
    id: "contact",
    title: "Get in touch",
    text: "Send Sinthu a message, she replies within a working day. Or keep asking me questions here.",
  },
];

export const AI_MATRIX = [
  {
    stage: "Preparing fieldwork",
    ai: "Research questions and hypotheses agreed with the product manager; recruiting operators, plant managers and partners; discussion guides in Danish and English, tightened with Claude and ChatGPT.",
  },
  {
    stage: "Interviews and transcription",
    ai: "Contextual interviews on site in Asia, Europe and the US, and online; recordings transcribed in EnjoyHQ where allowed, structured notes where not.",
  },
  {
    stage: "Analysis and insight development",
    ai: "200+ interviews coded in EnjoyHQ and spreadsheets, clustered in Miro; I ask Claude to propose themes and point out what I have not covered.",
  },
  {
    stage: "Report and presentation",
    ai: "Journey maps, archetypes, zone requirements and the Power BI benchmark, presented from product manager to CEO; AI drafts summaries and slide skeletons.",
  },
  {
    stage: "Tracking and testing",
    ai: "Surveys (SurveyXact, SurveyMonkey), NPS/CSAT loops and product analytics, so the next decision starts from data, not from memory.",
  },
];

export const METHOD_INTRO = "How I run a research project end to end, stage by stage, with AI as one part of the work.";
export const STAKEHOLDER_NOTE = {
  title: "Stakeholder management, across every stage",
  body: "It never sits in one stage, because every project needs it differently. From the first hypothesis to the last follow-up I keep product managers, the Pricing Director and senior management in the loop, so the insight is trusted before it lands and acted on after. It is what turns research into a decision.",
};

export const CASE_STUDIES = [
  {
    slug: "power-bi-benchmarking",
    label: "01 / Power BI",
    title: "Benchmarking our value proposition against key competitors",
    short: "Value-proposition benchmarking, PM to CEO",
    subtitle: "A Power BI model of our value proposition vs. key competitors, the fact base for pricing, positioning and strategy from PM to CEO.",
    hero: ASSETS.dashboard,
    metrics: [
      { value: "4", label: "Perspectives, internal, partner, customer, non-customer" },
      { value: "12", label: "Competitors tracked" },
      { value: "300+", label: "Feedback data points" },
      { value: "CEO", label: "Reached decision-maker" },
    ],
    context: `Pricing and senior management needed a repeatable, fact-based view of how our value proposition compared with key competitors, a living instrument, not a one-off deck.`,
    approach: `Multi-perspective survey (internal, partner, customer, non-customer), structured coding and a Power BI model filterable by department, metric, competitor and industry.`,
    aiUsage: `AI automated ingestion, first-pass coding and chart drafting. Framing, axes and the executive narrative stayed with me.`,
    outcomes: [
      "Adopted as the fact base for competitive benchmarking, pricing and positioning decisions.",
      "Presented and used from product manager level up to the CEO.",
      "Ad-hoc benchmarking requests fell to near zero, the dashboard answered them.",
    ],
    artifacts: [
      {
        src: ASSETS.urArtifacts.cxDashboard,
        title: "Customer Experience dashboard, the sister instrument",
        caption: "UR customer-experience dashboard (NPS, CSAT, CES by touchpoint), the sister instrument to the benchmarking model.",
        wide: true,
      },
    ],
    artifactsNote: "UR programme artefact. The benchmarking dashboard itself contains competitor data and is not published.",
    story: {
      org: "Universal Robots",
      period: "Universal Robots · 2024, 2025",
      quote: {
        text: "Our senior management team, including the CEO, were tremendously impressed with the first results and how this could be used on an operational and strategic level. This is what outstanding researchers, analysts and strategists do!",
        who: "Piotr M. Klima · Pricing Director, Universal Robots",
      },
      tags: ["Competitive benchmarking", "Power BI", "Pricing & positioning"],
      inShort: [
        "Universal Robots needed a repeatable, fact-based view of how its value proposition compared with key competitors. I built a multi-perspective survey and a Power BI model that turned 300+ data points into a living instrument for pricing, positioning and strategy.",
        "The result: one dashboard used from product manager to CEO, and a senior management team that was, in the Pricing Director's words, \"tremendously impressed\".",
      ],
      facts: [
        { icon: "Building2", label: "Organisation", value: "Universal Robots A/S · Odense, Denmark" },
        { icon: "Users", label: "Stakeholders", value: "Pricing Director, product managers, senior management, CEO" },
        { icon: "ClipboardList", label: "Solution", value: "Value-proposition benchmarking model in Power BI" },
        { icon: "Wrench", label: "Tools used", value: "Power BI, SurveyXact, Excel, AI-assisted coding" },
      ],
      challenge: {
        text: "Benchmarking lived in one-off decks. Every pricing or positioning question triggered a new round of ad-hoc analysis, and the answers rarely agreed.",
        bullets: [
          "No shared fact base across pricing, product and management",
          "Competitor comparisons rebuilt from scratch for each request",
          "Internal views never tested against partners, customers and non-customers",
          "Slow turnaround from question to decision",
        ],
      },
      needed: [
        "Compare the value proposition against 12 key competitors on one scale",
        "Combine internal, partner, customer and non-customer perspectives",
        "Filter by department, metric, competitor and industry",
        "Stay current without a researcher in the loop for every question",
      ],
      solution: {
        heading: "From one-off decks to a living benchmarking instrument",
        paragraphs: [
          "I designed a multi-perspective survey (internal, partner, customer, non-customer), coded the responses into a structured framework and built the Power BI model on top, filterable by department, metric, competitor and industry.",
          "AI automated ingestion, first-pass coding and chart drafting. The framing, the axes and the executive narrative stayed with me, and were presented from PM level up to the CEO.",
        ],
      },
      columns: [
        { title: "Key value drivers", items: ["Fact-based pricing and positioning", "One shared view from PM to CEO", "Repeatable instead of ad hoc", "Faster from question to decision"] },
        { title: "Tasks solved by the model", items: ["Competitive benchmarking of the value proposition", "Multi-perspective feedback consolidation", "Executive share-outs and strategy input"] },
        { title: "Challenges solved", items: ["Fragmented competitor knowledge", "Ad-hoc benchmarking requests", "Untested internal assumptions", "Slow decision cycles"] },
      ],
    },
    reflection: `Next time: a 20-minute data-literacy walkthrough for each stakeholder. The dashboard was powerful; the leap from "dashboard exists" to "dashboard changes a decision" is smaller when people can read it themselves.`,
  },
  {
    slug: "sip-and-serve",
    label: "02 / Sip & Serve TCO",
    title: "A growth loop built from scratch, product, revenue, community, analytics",
    short: "Growth loop built from scratch with AI",
    subtitle: "A PWA for a 478-member club, ticketing, surveys, live NPS/CSAT and community, built solo with AI and measured commercially.",
    hero: "/artifacts/sip-serve-hero.jpg",
    metrics: [
      { value: "+66", label: "NPS, 29 responses" },
      { value: "65+", label: "Participants on the day" },
      { value: "38/38", label: "App tickets sold out · 12 on waitlist" },
      { value: "124.6k", label: "Organic Facebook views (+1,186%)" },
    ],
    context: `As a board member I built and shipped Sip & Serve TCO solo, with AI as coding partner: the research system, the analytics and the feedback loop, with real users and real revenue.`,
    approach: `Product: PWA, auth, MobilePay ticketing, QR check-in, pre/post surveys, live NPS/CSAT, admin dashboard, push, EN/DA. Method: discovery with volunteers, survey design, analysis, iteration.`,
    aiUsage: `Claude as copilot in VS Code, Supabase backend, Resend and GitHub, deployed on Netlify. AI also assisted survey, analysis and comms; decisions stayed with the team.`,
    outcomes: [
      "Sold out, 38/38 tickets, 12 on the waitlist, 65+ participants.",
      "NPS +66 (29 responses) · 9.4/10 would recommend.",
      "Organic reach +1,186%, followers +400%, event team 4 → 15.",
      "Two pre-event articles and TV2 Fyn coverage on the day.",
    ],
    csat: {
      headline: "From survey to decision, one loop, closed",
      intro: "Pre- and post-event surveys ran inside the app. What members said, and what the board did with it.",
      scores: [
        { value: "+66", label: "NPS · 29 responses" },
        { value: "9.4 / 10", label: "Recommend to a tennis friend · post-event" },
        { value: "4.5 / 5", label: "Concept rating before the event · 18 responses" },
        { value: "82%", label: "'Perfect balance tennis / social' · 9 of 11" },
      ],
      loops: [
        {
          insight: "63% want more matches; 82% call the tennis/social balance 'perfect'.",
          action:
            "Next edition: more court time, same social format.",
        },
        {
          insight: "52% knew about the event more than a month ahead.",
          action:
            "Long comms runway and press timeline kept as the club standard.",
        },
        {
          insight: "12 on the waitlist after 38/38 sold out; 6 more sold at the door.",
          action:
            "Capacity and ticket tiers first on the next-edition agenda.",
        },
      ],
      quotes: [
        { text: "Klubben var virkelig fint pyntet og fællesskabet var i fokus.", who: "Annika Jarl, member" },
        { text: "The slam took all the lights, and rightly so. So much fun!", who: "Francisco S. Acosta, member" },
      ],
    },
    reflection: `Live analytics change how a volunteer team behaves. A real-time NPS chart did more than any post-event report could.`,
    story: {
      org: "Tennis Club Odense",
      period: "Tennis Club Odense · 2026",
      quote: {
        text: "The slam took all the lights, and rightly so. So much fun!",
        who: "Francisco S. Acosta · member, post-event survey",
      },
      tags: ["Research system", "Live analytics", "Community & feedback loop"],
      inShort: [
        "As a voluntary board member I built and shipped Sip & Serve TCO, a PWA with ticketing, surveys, live NPS/CSAT and community features, solo, with AI as coding partner, for a 478-member club.",
        "The result: a sold-out event, NPS +66, organic reach +1,186% and a feedback loop the board now plans the next edition on.",
      ],
      facts: [
        { icon: "Building2", label: "Organisation", value: "Tennis Club Odense · 478 members · Denmark" },
        { icon: "UserCheck", label: "Role", value: "Voluntary board member, event, funding, marketing" },
        { icon: "ClipboardList", label: "Solution", value: "Event platform with built-in research system and live analytics" },
        { icon: "Wrench", label: "Tools used", value: "Claude as copilot in VS Code, Supabase backend, Resend, GitHub, deployed on Netlify, MobilePay, in-app surveys" },
      ],
      challenge: {
        text: "The club wanted a new flagship event but had no way to sell tickets, hear from members or measure success beyond a headcount.",
        bullets: [
          "No digital channel for ticketing or check-in",
          "Member feedback anecdotal, never structured",
          "Volunteer team of four with limited time",
          "No baseline to judge the next edition against",
        ],
      },
      needed: [
        "Sell tickets and check members in without manual admin",
        "Capture pre- and post-event feedback inside the same product",
        "Show live NPS/CSAT the volunteer team could act on",
        "Grow reach and the team without a budget",
      ],
      solution: {
        heading: "From a headcount to a measured growth loop",
        paragraphs: [
          "I built the platform end to end: PWA, auth, MobilePay ticketing, QR check-in, pre/post surveys, live NPS/CSAT, admin dashboard, push notifications, EN/DA. Discovery with volunteers, survey design and iteration followed the same method I use professionally.",
          "Built with Claude as copilot in VS Code: front end and Supabase backend with Resend and GitHub integrations, deployed manually on Netlify. AI also assisted the survey design, analysis and comms. Design decisions, member conversations and trade-offs stayed with the team.",
        ],
      },
      columns: [
        { title: "Key value drivers", items: ["Revenue and capacity data in real time", "Member sentiment captured, not guessed", "Next edition briefed on evidence", "Team grown 4 → 15 on the momentum"] },
        { title: "Tasks solved by the platform", items: ["Ticketing, check-in and waitlist", "Pre/post surveys with live NPS/CSAT", "Community gallery and communications"] },
        { title: "Challenges solved", items: ["Manual admin", "Anecdotal feedback", "No success baseline", "Limited reach without budget"] },
      ],
    },
    gallery: ASSETS.sipServe,
    liveUrl: "https://sipandservetco.netlify.app/",
  },
  {
    slug: "food-industry-ur",
    label: "03 / Food industry",
    title: "Segment discovery on the factory floor, what it takes to win food & beverage",
    short: "Segment discovery in food & beverage",
    subtitle: "Global discovery across four hygienic zones, QA requirements translated into segment requirements and roadmap priorities.",
    hero: ASSETS.factory,
    metrics: [
      { value: "PM", label: "Segment roadmap prioritised on the evidence" },
      { value: "200+", label: "Operator, QA & management interviews" },
      { value: "3", label: "Continents, Asia, Europe, US" },
      { value: "4", label: "Regulatory zones" },
    ],
    context: `What does an industrial digital product need to survive, physically, operationally, commercially, inside a food factory? The answer changes every ten metres.`,
    approach: `Plant visits across Asia, Europe and the US and 200+ interviews with operators, QA leads and plant management, contextual inquiry, requirement interviews, journey mapping.`,
    aiUsage: `AI tightened the discussion guides and proposed clusters; recordings were transcribed in EnjoyHQ. Sampling, theming and every recommendation stayed with me.`,
    outcomes: [
      "Application overview that became the basis for prioritising the segment roadmap.",
      "Shared vocabulary between QA (hard/soft requirements), product and engineering.",
      "Zone map used by product managers as the reference when evaluating features.",
      "QA requirements now surface at Evaluate and Deploy in the customer lifecycle model.",
    ],
    artifacts: [
      {
        src: ASSETS.urArtifacts.journeyMap,
        title: "End-to-end customer journey map (anonymised format)",
        caption: "The journey-map format used in the UR research programme (anonymised). Food-industry findings were placed against these lifecycle stages.",
        wide: true,
      },
      {
        src: ASSETS.urArtifacts.archetypes,
        title: "Behavioural archetypes",
        caption: "Behavioural archetypes from the UR insights programme, the same archetype could sit in a wet zone or a palletising cell.",
      },
      {
        src: ASSETS.urArtifacts.lifecycleLoop,
        title: "Customer lifecycle, before & after purchase",
        caption: "Onboard → Deploy → Play → Guidance → Advocacy. Food-industry QA requirements surfaced at Evaluate and again at Deploy.",
      },
    ],
    artifactsNote: "UR Customer Experience, Insights & Research programme artefacts, shown in anonymised form. Plant-visit photos are under NDA.",
    story: {
      org: "Universal Robots",
      period: "Universal Robots · 2022, 2024",
      quote: {
        text: "Sinthu is not only incredibly dedicated and detail oriented, but she also brings a positive energy to every project. Her problem-solving skills and enthusiasm make her a fantastic team player. I highly recommend Sinthu to anyone looking for a committed and talented UX researcher!",
        who: "Johannes Callø · Product Owner, Pharma, Life Science & Food & Beverage",
      },
      tags: ["Global discovery", "Segment requirements", "Journey mapping"],
      inShort: [
        "Universal Robots needed to understand what it takes to win in food & beverage. I ran global discovery with 200+ interviews on three continents and translated QA requirements per hygienic zone into segment requirements.",
        "The result: an application overview that became the basis for prioritising the segment roadmap, and a zone map product managers use when evaluating features.",
      ],
      facts: [
        { icon: "Building2", label: "Organisation", value: "Universal Robots A/S · Food & beverage segment" },
        { icon: "Globe", label: "Markets", value: "Asia, Europe and the US · plant visits" },
        { icon: "ClipboardList", label: "Solution", value: "Segment discovery and requirement mapping across four hygienic zones" },
        { icon: "Wrench", label: "Tools used", value: "Contextual inquiry, EnjoyHQ transcription, semantic clustering, journey mapping" },
      ],
      challenge: {
        text: "Food factories change their requirements every ten metres. Product, QA and engineering lacked a shared picture of what an industrial digital product must survive, physically, operationally and commercially.",
        bullets: [
          "Requirements differed by zone (IP69K, ATEX, IP67, IP54) and by role",
          "QA language and product language did not match",
          "Findings scattered across regions and teams",
          "No prioritised view for the roadmap",
        ],
      },
      needed: [
        "Define customer needs, pain points and opportunities globally",
        "Map requirements per hygienic zone and target group",
        "Give QA, product and engineering one vocabulary",
        "Feed the segment roadmap with evidence, not opinion",
      ],
      solution: {
        heading: "From scattered plant visits to a segment roadmap",
        paragraphs: [
          "Contextual inquiry, requirement interviews and journey mapping across plant visits in Asia, Europe and the US with 200+ operators, QA leads and plant managers, placed against the end-to-end customer journey and behavioural archetypes.",
          "AI tightened the discussion guides and proposed clusters; recordings were transcribed in EnjoyHQ. Sampling, theming and every recommendation stayed with me.",
        ],
      },
      columns: [
        { title: "Key value drivers", items: ["Roadmap prioritised on evidence", "Hard and soft requirements made explicit", "Shared vocabulary across QA, product and engineering", "Reusable zone map for feature decisions"] },
        { title: "Tasks solved by the research", items: ["Global discovery on three continents", "Requirements per zone and target group", "Journey maps and behavioural archetypes"] },
        { title: "Challenges solved", items: ["Fragmented regional knowledge", "QA vs product language gap", "Opinion-led prioritisation", "Missing segment reference"] },
      ],
    },
    reflection: `Next time: a synchronous decision-mapping session with QA leads earlier, it would have compressed the requirements phase by weeks.`,
  },
  {
    slug: "unboxing-ur",
    secondary: true,
    label: "04 / Unboxing",
    title: "The unboxing journey: from delivery to first program",
    short: "Observational research on the cobot unboxing journey",
    subtitle: "Six months of observational research at Universal Robots on how first-time customers unbox, mount and start a cobot, mapped into a 12-touchpoint journey with prioritised insights and a threefold concept.",
    hero: "/artifacts/ur-unboxing-journey-map.jpg",
    metrics: [
      { value: "12", label: "Touchpoints mapped, delivery to first program" },
      { value: "2", label: "Test phases, internal then external" },
      { value: "11 / 14", label: "Internal test users found box information insufficient" },
      { value: "3", label: "Personas: Online_floor, Online_offsite, Offline" },
    ],
    context: `The box had not been redesigned since 2015 and UR had no data on what happens between delivery and first use. Feedback pointed at cardboard quality, but nobody had observed the journey.`,
    approach: `Observational experiments in two phases (internal across sales, marketing and R&D, then external technical and non-technical users), think-aloud, multi-angle video coding, expert interviews and MyUR case data. Journey documented in UXPressia.`,
    aiUsage: `No AI in this 2022 study. Coding and clustering were done by hand in video review and spreadsheets; today I would run the same synthesis with Claude proposing clusters and me validating them.`,
    outcomes: [
      "12-touchpoint customer journey map with emotion curve, pain points and opportunities per touchpoint.",
      "Insights prioritised MoSCoW-style: foam, manual, mounting and power connection as the urgent friction.",
      "Three personas (Online_floor, Online_offsite, Offline) and a threefold concept: quickstart guide, QR landing page, AR.",
      "Usability-test plan for the new journey, analysing and adjusting after every five test users.",
    ],
    artifacts: [
      {
        src: "/artifacts/ur-unboxing-journey-map.jpg",
        title: "Unboxing customer journey map",
        caption: "Twelve touchpoints from receiving the boxes to the first program, with the observed emotion curve, pain points and MoSCoW-prioritised opportunities. Reconstructed from the study for the portfolio; the original UXPressia map is internal.",
        wide: true,
      },
      {
        src: "/artifacts/ur-unboxing-insight-foam.jpg",
        title: "Insight card: the foam",
        caption: "9 of 10 internal test users in Denmark found the foam inconvenient: hard to grip, noisy, every accessory out before the arm, and a storage problem afterwards.",
      },
      {
        src: "/artifacts/ur-unboxing-insight-box.jpg",
        title: "Insight card: information on the box",
        caption: "11 of 14 internal employees experienced insufficient information on and in the box and judged it low quality; several did not realise there were two boxes.",
      },
    ],
    artifactsNote: "Insight cards and journey map from the 2022 unboxing study, shown with the R&D department's approval for public use. Test-user video is internal.",
    story: {
      org: "Universal Robots",
      period: "Universal Robots · 2022",
      tags: ["Observational research", "Journey mapping", "Concept development"],
      inShort: [
        "Universal Robots had no data on what happens between delivery and first use of a cobot. Over six months I observed first-time users unboxing, mounting and starting the UR3e and UR5e, and mapped the journey touchpoint by touchpoint.",
        "The result: a 12-touchpoint journey map with prioritised insights, three personas and a threefold concept for a new unboxing experience, plus the usability-test plan to validate it.",
      ],
      facts: [
        { icon: "Building2", label: "Organisation", value: "Universal Robots A/S · R&D and UX" },
        { icon: "Globe", label: "Scope", value: "UR3e and UR5e · semi-independent first-time customers" },
        { icon: "ClipboardList", label: "Solution", value: "Journey map, prioritised insights, personas and a threefold unboxing concept" },
        { icon: "Wrench", label: "Tools used", value: "Observational experiments, think-aloud, video coding, expert interviews, UXPressia, MoSCoW" },
      ],
      challenge: {
        text: "Cobots are sold on easy deployment, yet the first physical experience, the box, had never been researched. Requirements had shifted since 2015 and the manual still addressed integrators, not the end customer unboxing alone.",
        bullets: [
          "No data on the unboxing journey or its friction points",
          "Cardboard and foam complaints, internally and from customers",
          "Manual written for integrators, not semi-independent customers",
          "74% of whole-robot service cases depend on the customer keeping the box",
        ],
      },
      needed: [
        "Document the current journey objectively, touchpoint by touchpoint",
        "Find where friction actually occurs, not where we assumed it did",
        "Turn observations into prioritised, structured insights",
        "Develop a holistic concept that works online, offline and on the floor",
      ],
      solution: {
        heading: "From an unobserved box to a prioritised journey",
        paragraphs: [
          "Two phases of observational experiments: internal test users across sales, marketing and R&D, then external users with technical and non-technical backgrounds. Each was given a realistic scenario and task, thinking aloud while unboxing, mounting and programming, recorded from three angles. Expert interviews and MyUR case data added the internal and service perspective.",
          "Patterns were clustered into structured insights, prioritised MoSCoW-style and placed on a UXPressia journey map with the emotional state at each touchpoint. Three personas framed the concept: a quickstart guide in physical form, a QR code to a landing page, and an AR option, tested for desirability and planned for usability testing in cycles of five.",
        ],
      },
      columns: [
        { title: "Key value drivers", items: ["First evidence base for the unboxing journey", "Friction ranked by impact and cost", "Concept covering online, offline and floor scenarios", "Internal storage problem addressed with the customer's"] },
        { title: "Tasks solved by the research", items: ["Observational experiments in two phases", "12-touchpoint journey map with emotion curve", "Personas and threefold concept", "Usability-test plan"] },
        { title: "Challenges solved", items: ["Assumption-led box feedback", "Integrator-only manual", "Hidden connection and mounting information", "No baseline to measure a redesign against"] },
      ],
    },
    reflection: `Recruiting real semi-independent customers proved hardest; simulated users covered the knowledge scale but not the mature buyer. Next time I would secure customer visits before the study starts.`,
  },
];

export const CV_METRICS = [
  { value: "200+", label: "Interviews on three continents, Universal Robots" },
  { value: "PM → CEO", label: "Power BI competitor benchmark adopted by leadership" },
  { value: "+66", label: "NPS on a growth loop built from scratch with AI" },
  { value: "+1,186%", label: "Organic reach, sold-out event, team 4 → 15" },
];

export const GRID_ENTRIES = [
  {
    title: "UR Academy: CSAT loop and Training Partner research",
    body: "Set up a CSAT for the Universal Robots Academy and made results transparent in regular webinars with the Training Partners. Engagement rose and the Academy shifted from assuming to measuring; the research refined focus and prioritised key topics.",
    tag: "Research & KPIs",
    quote: { text: "Sinthus research insights have made a tangible impact on our decision-making processes.", who: "Sven Krüger · UR Academy" },
  },
  {
    title: "Customer journey workshops",
    body: "Facilitated cross-functional journey-mapping sessions, prep, moderation, synthesis. Focused on stakeholder alignment, not systems.",
    tag: "Facilitation",
  },
  {
    title: "Robot unboxing research",
    body: "Six months of observational research on how first-time customers unbox, mount and start a cobot: a 12-touchpoint journey map, prioritised insights and a threefold concept.",
    tag: "Field research",
    to: "/case-studies/unboxing-ur",
    cta: "Read the case",
  },
];

export const EXPERIENCE = [
  {
    period: "2026 to present",
    role: "Board Member",
    note: "Voluntary position",
    org: "Tennis Club Odense (TCO)",
    body: "Board of Fyn's largest tennis club (478 members). Built and shipped the Sip & Serve event platform with AI; responsible for member CSAT, growth and press.",
    focus: "This season: event management, leading the funding committee, marketing strategy, organisational structuring and process optimisation.",
  },
  {
    period: "Aug 2021 to May 2025",
    role: "UX Researcher",
    org: "Universal Robots A/S",
    body: "Global discovery, journey mapping and competitive benchmarking for product, pricing and senior management, reporting from PM to CEO.",
  },
  {
    period: "2019 to 2022",
    role: "Counter Manager",
    org: "Magasin du Nord",
    body: "Retail leadership, customer-facing operations and team management.",
  },
];

export const EDUCATION = [
  {
    period: "2021 to 2022",
    title: "Digital Concept Development",
    org: "UCL Erhvervsakademi & Professionshøjskole",
    note: "All A grades",
  },
  {
    period: "2016 to 2019",
    title: "Market & Management Anthropology (MMA)",
    org: "SDU, University of Southern Denmark",
  },
];

export const CERTS = [
  "Microsoft Power BI & Data Visualisation Mastery",
  "Future Skills Talent Programme (UCL)",
  "Innovative Event Management",
  "Project Management, Copenhagen Business Academy",
];

export const SKILLS = [
  {
    group: "Commercial & business analysis",
    items: [
      "Competitive benchmarking",
      "Value-proposition analysis",
      "Exploratory market research",
      "Pricing & positioning input",
      "Growth & channel analytics",
    ],
  },
  {
    group: "Discovery & qualitative",
    items: [
      "Global discovery research",
      "Contextual inquiry",
      "Customer visits & interviews",
      "Industry fairs",
      "Observational testing",
    ],
  },
  {
    group: "Mapping & modelling",
    items: [
      "Customer journey maps",
      "Archetypes & personas",
      "Requirements per target group",
      "Segment requirement mapping",
    ],
  },
  {
    group: "Quantitative & analytics",
    items: [
      "Surveys & NPS / CSAT loops",
      "Power BI",
      "Product analytics setup",
      "Live dashboards",
      "Data storytelling",
    ],
  },
  {
    group: "AI in research",
    items: [
      "AI-drafted interview protocols",
      "EnjoyHQ transcription",
      "Semantic clustering",
      "AI-assisted synthesis",
      "AI as coding partner",
    ],
  },
  {
    group: "Validation & feedback loop",
    items: [
      "Feature usability tests",
      "Beta testing & feedback capture",
      "Community building",
      "Working with UX architects & designers",
      "SMT / CEO share-outs",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Piotr M. Klima",
    role: "Pricing Director · senior stakeholder, Universal Robots",
    relation: "Senior stakeholder · 1 Feb 2025",
    pull:
      "Our senior management team, including the CEO, were tremendously impressed with the first results and how this could be used on an operational and strategic level.",
    quote: `We have been working with Sinthu for a couple of months on a way to revolutionise competitive benchmarking of our value proposition against the key competitors and their solutions. This required out-of-the-box thinking, creativity, agility, and the use of software tools. Sinthu managed these all with great care and delivered extremely promising results with their professional visualisation. Our senior management team, including the CEO, were tremendously impressed with the first results and how this could be used on an operational and strategic level. Sinthu significantly contributed to building fact-bases competitive benchmarking processes and strategic analysis. This is what outstanding researchers, analysts and strategists do!`,
    featured: true,
  },
  {
    name: "Sven Krüger",
    role: "UR Academy · Cobot education, Universal Robots",
    relation: "Worked together across teams · 24 Feb 2025",
    pull:
      "Sinthus research insights have made a tangible impact on our decision-making processes.",
    quote: `I want to express my deep appreciation for the exceptional work Sinthu did, in particularly in a huge Training Partner Research project we collaborated on but also in ongoing fast support. It provided tremendous value to our work in the UR Academy.

The research not only confirmed our existing approach but also helped us refine our focus, prioritize key topics, and understand that our Training Partners are highly satisfied with our program. Although we had conducted surveys and research in the past, but Sinthu and her expertise and data-driven approach have significantly enhanced our ability to address the needs of our customers and Training Partners with precision.

Sinthus research insights have made a tangible impact on our decision-making processes.

I want to highlight the importance of involving research teams. I've seen firsthand how valuable data can be lost when conducted outside of a structured approach. By collaborating with Sinthu, we ensured that the data is properly consolidated and can be leveraged for long-term benefits.`,
    featured: true,
  },
  {
    name: "Jacob Mohr Jensen",
    role: "Development consultant · Anthropologist, ex-UX Research UR",
    relation: "Same UX research team · 6 Feb 2025",
    pull:
      "We worked in a field with a high degree of technical details, a complex business structure and with a wide variation of customer profiles. In my view Sinthus greatest feat is her ability to naturally tie these different aspects in a meaningful and respectful way.",
    quote: `I have had the great pleasure of working with Sinthu for almost three years at Universal Robots. We worked closely together in a small group of UX researchers in which Sinthu stood out with her many qualifications. It is rare to come across a person that is as energetic, kind-hearted and solution oriented like Sinthu is. In my experience Sinthu always strives for the best possible outcome which is communicated through humility and an out-reaching attitude. We worked in a field with a high degree of technical details, a complex business structure and with a wide variation of customer profiles. In my view Sinthus greatest feat is her ability to naturally tie these different aspects in a meaningful and respectful way. Sinthu often times makes this look easy because she enjoys establishing and nuturing social relations in every organisation she enters, meaning that she would usually immediately know who to bring in for the task.
I warmly recommend Sinthu Nathan to any workplace, and I am envious of whoever gets to become Sinthus new colleague.`,
  },
  {
    name: "Azadeh Sabouri",
    role: "Lead Customer Experience Insights & User Research, Universal Robots",
    relation: "Sinthu's mentor · 5 Feb 2025",
    pull:
      "Her willingness to listen and learn has enabled her to grow in her role and take on more responsibilities at Universal Robots.",
    quote: `Sinthu is a passionate and energetic professional with big ambitions.
She brings a diverse skill set from her past experiences, seamlessly juggling multiple tasks while building strong relationships. Her willingness to listen and learn has enabled her to grow in her role and take on more responsibilities at Universal Robots. With her continuously expanding expertise, she is a valuable asset to any team!`,
  },
  {
    name: "Johannes Callø",
    role: "Product Owner · Pharma, Life Science & Food & Beverage segments",
    relation: "Senior stakeholder · 5 Feb 2025",
    pull:
      "Incredibly dedicated and detail oriented, a great ability to get the job done efficiently while maintaining a collaborative and friendly approach.",
    quote: `I had the pleasure of working closely with Sinthu Nathan
Exploring user experiences in the pharmaceutical and food & beverage industries.
Sinthu is not only incredibly dedicated and detail oriented, but she also brings a positive energy to every project.
She has a great ability to get the job done efficiently while maintaining a collaborative and friendly approach. Her problem-solving skills and enthusiasm make her a fantastic team player.

I highly recommend Sinthu to anyone looking for a committed and talented UX researcher!`,
    featured: true,
  },
  {
    name: "Gui Webster",
    role: "Product Design Lead · MBA, M.Eng.",
    relation: "Same team · 7 Feb 2025",
    pull:
      "From initial research into robot unboxing to helping Senior Management with crucial strategic insights, she has come a long and fast-paced way.",
    quote: `I have witnessed Sinthu's tremendous professional growth during her time at Universal Robots: from initial research into robot unboxing (an important but overlooked area) to helping Senior Management with crucial strategic insights, she has come a long and fast-paced way, always getting along well with everyone, either engineers or the CEO himself. She's dedicated, flexible, joyful, highly driven: and highly recommended!`,
  },
  {
    name: "Jannik Grann",
    role: "UX Researcher · Anthropologist",
    relation: "Same team · 5 Feb 2025",
    pull:
      "She has an ability to take complex user needs and turn them into clear, actionable improvements. Her work doesn't just check a box, it genuinely makes a difference.",
    quote: `Sinthu is an fantastic UX researcher who not only knows her craft but also brings a contagious energy to every project. She's great with people, whether it's building relationships, managing stakeholders, or making sure insights actually drive decisions. She has an ability to take complex user needs and turn them into clear, actionable improvements. Her work doesn't just check a box, it genuinely makes a difference. Working with her has been a pleasure, and I would highly recommend her anytime.`,
  },
  {
    name: "Allan Syndergaard",
    role: "Product & UX Design Lead · NN/g UX Master",
    relation: "Same team · 6 Feb 2025",
    pull:
      "She is structured, she is thorough and she takes her work very seriously. She has helped me with many usability tests and research tasks and always delivered great insights and actionable results.",
    quote: `Sinthu brings great energy to any office. She is always in a good mood, spreads positivity and genuinely cares about people around her. She really makes an effort to connect - whether it is an enthusiastic "Good morning!" or a simple chat when needed.

Workwise she is a skilled researcher. She is structured, she is thorough and she takes her work very seriously. When you collaborate with her, she gives you her full attention. She has helped me with many usability tests and research tasks and always delivered great insights and actionable results.

Outside of work I also commuted with her to work for a while - which led to many good conversations. She is thoughtful, easy to talk to and has a great sense of humor.

I can highly recommend Sinthu. Any team would be lucky to have her!`,
  },
  {
    name: "Alexander Munkholm Madsen",
    role: "Senior UX Consultant · Product Designer",
    relation: "Same team · 5 Feb 2025",
    pull:
      "She has a deep understanding of people and the UX process, always bringing valuable insights to the team.",
    quote: `Sinthu has demonstrated outstanding professionalism and a strong eagerness to learn. She has a deep understanding of people and the UX process, always bringing valuable insights to the team. Beyond her skills, Sinthu contributes with an optimistic spirit that positively influences the workplace. I highly recommend Sinthu and I'm confident she will be a great asset.`,
    featured: true,
  },
];

export const RECOMMENDATIONS_URL =
  "https://www.linkedin.com/in/sinthunathan/details/recommendations/";

export const ZONES = [
  {
    name: "Wet cleaning zone",
    rating: "IP69K",
    body: "High-pressure washdown, chemical exposure, worker safety in damp environments.",
  },
  {
    name: "Middle prep zone",
    rating: "ATEX",
    body: "Explosive-dust safety, flour and powder containment, ergonomic operator interfaces.",
  },
  {
    name: "Dry packaging zone",
    rating: "IP67",
    body: "Sealed dust/water protection, high-speed automated packaging, line-side analytics.",
  },
  {
    name: "Palletising zone",
    rating: "IP54",
    body: "Robotic safety clearance, cobot interaction, floor-operator UX and handoff moments.",
  },
];

export const JOURNEY = [
  {
    id: "awareness",
    stage: "Awareness",
    title: "Meet Sinthu",
    touchpoint: "About me",
    mood: 1,
    sectionId: "about",
    blurb:
      "Customer Insights & Growth Researcher from Odense. Global discovery research at Universal Robots, and a research system built from scratch with AI since.",
    facts: [
      "Global discovery research, needs, pain points, opportunities on three continents",
      "Reported from PM to VP and CEO",
      "Danish · English · French",
    ],
    cta: { to: "#about", label: "Read About" },
  },
  {
    id: "consideration",
    stage: "Consideration",
    title: "Experience",
    touchpoint: "Track record",
    mood: 2,
    sectionId: "experience",
    blurb:
      "Five years of research practice, Power BI certified, all-A Digital Concept Development degree, board seat at Fyn's biggest tennis club.",
    facts: [
      "Universal Robots UX Researcher 2021 to 2025",
      "Tennis Club Odense board member 2026, (voluntary)",
      "Microsoft Power BI & Data Visualisation Mastery",
    ],
    cta: { to: "#experience", label: "See experience" },
  },
  {
    id: "trust",
    stage: "Trust",
    title: "Personality",
    touchpoint: "CliftonStrengths",
    mood: 3,
    sectionId: "personality",
    blurb:
      "Gallup CliftonStrengths 34: she leads with Influencing. Woo, Strategic, Significance, Communication and Adaptability, measured, not self-described.",
    facts: [
      "Top 5: Woo · Strategic · Significance · Communication · Adaptability",
      "Researcher and business strategist in one profile",
      "Full Gallup report linked on the page",
    ],
    cta: { to: "#personality", label: "See personality" },
  },
  {
    id: "evaluation",
    stage: "Evaluation",
    title: "Case studies",
    touchpoint: "Top 3 cases",
    mood: 3,
    sectionId: "projects",
    blurb:
      "A competitive-benchmarking model the CEO decides with, a growth loop built and measured on real users, and segment discovery on the factory floor.",
    facts: [
      "Food industry, hygienic zones IP69K / ATEX / IP67 / IP54",
      "Sip & Serve, NPS +66, 38/38 tickets sold out, 65+ participants",
      "Power BI, value-proposition benchmarking, CEO 'tremendously impressed'",
    ],
    cta: { to: "#projects", label: "Browse case studies" },
  },
  {
    id: "experience",
    stage: "Experience",
    title: "Methodology",
    touchpoint: "Five stages",
    mood: 3,
    sectionId: "ai-methodology",
    blurb:
      "How she runs a research project end to end, in five stages, with AI as one part of the work and stakeholder management across all of it.",
    facts: [
      "Preparing fieldwork, interviews and transcription, analysis and insight development",
      "Report and presentation from product manager to CEO, then tracking and testing",
      "AI tightens guides, proposes clusters and drafts synthesis; coding in EnjoyHQ",
    ],
    cta: { to: "#ai-methodology", label: "See the method" },
  },
  {
    id: "advocacy",
    stage: "Advocacy",
    title: "Recommendations",
    touchpoint: "9 verbatim quotes",
    mood: 4,
    sectionId: "testimonials",
    blurb:
      "Nine LinkedIn recommendations, nothing paraphrased, from a Pricing Director to fellow researchers and her mentor.",
    facts: [
      "\"This is what outstanding researchers, analysts and strategists do!\", Piotr M. Klima",
      "\"A tangible impact on our decision-making processes.\", Sven Krüger",
      "\"Genuinely makes a difference.\", Jannik Grann",
    ],
    cta: { to: "#testimonials", label: "Read them" },
  },
  {
    id: "conversion",
    stage: "Conversion",
    title: "Let's talk",
    touchpoint: "Contact · CV",
    mood: 4,
    sectionId: "contact",
    blurb:
      "The loop closes here. Send a message, replies within a working day, or download the CV.",
    facts: [
      "Contact form stores straight to Sinthu's inbox",
      "CV as PDF, one click",
      "This portfolio measures its own funnel, you're in it",
    ],
    cta: { to: "#contact", label: "Contact Sinthu" },
  },
];

export const SENTIMENT_REACTIONS = {
  awareness: {
    slug: "power-bi-benchmarking",
    text: "Not convinced yet? Fair enough, you have only met her. Skip the intro and go to the Power BI benchmark the CEO was 'tremendously impressed' by. Two minutes.",
  },
  consideration: {
    slug: "sip-and-serve",
    text: "If the experience section did not land, see it done rather than described: she built the research system from scratch, with AI, and shipped it. Sip & Serve, NPS +66.",
  },
  evaluation: {
    slug: "food-industry-ur",
    text: "AI on a slide is cheap. Here it is in the field: plant visits on three continents, 200+ interviews, every quote re-read against the source.",
  },
  experience: {
    slug: "power-bi-benchmarking",
    text: "If the case studies did not convince you, try the one with the CEO in it: the benchmarking dashboard that answered leadership's questions before they were asked.",
  },
  trust: {
    slug: "sip-and-serve",
    text: "If the track record feels thin, look at what she did without a job title: a shipped product, live NPS/CSAT and a volunteer team grown from 4 to 15.",
  },
  advocacy: {
    slug: "food-industry-ur",
    text: "If nine recommendations did not move you, let the work speak: the food-industry discovery that became a roadmap reference.",
  },
  conversion: {
    slug: "sip-and-serve",
    text: "Not ready to reach out? No pressure. One last thing: the case study closest to your brief. Build the system with AI, measure, iterate.",
  },
};

export const NUDGES = {
  hero: {
    text: "Sinthu works in Danish, English and French, useful when your customers are on three continents.",
    to: "#about",
    cta: "See About",
  },
  journey: {
    text: "This is an interactive customer journey map, the artefact Sinthu builds for a living, here mapping your visit. Click any stage for the short version, tap a smiley to rate it, and the dashed line becomes live visitor sentiment.",
    to: "#journey",
    cta: "Try a stage",
    walk: "Walk me through the map",
  },
  about: {
    text: "She built the whole Sip & Serve app solo, with AI as copilot. Real users, real analytics.",
    to: "/case-studies/sip-and-serve",
    cta: "Show me",
  },
  personality: {
    text: "Her top CliftonStrengths are Woo and Strategic: meeting strangers energises her, and she sees the pattern before the room does. Useful in global discovery.",
    to: "#projects",
    cta: "See it applied",
  },
  "ai-methodology": {
    text: "She coded 200+ interviews in EnjoyHQ and re-reads every quote against the source before it goes in a report.",
    to: "/case-studies/food-industry-ur",
    cta: "See it in the field",
  },
  projects: {
    text: "The CEO was 'tremendously impressed' by her Power BI benchmarking, in the words of Pricing Director Piotr M. Klima.",
    to: "/case-studies/power-bi-benchmarking",
    cta: "Read that one",
  },
  "live-stats": {
    text: "These numbers are real and live, and your visit is in them. A researcher who measures her own portfolio.",
    to: "/analytics",
    cta: "Open dashboard",
  },
  experience: {
    text: "She graduated Digital Concept Development with all A grades and is Microsoft Power BI certified.",
    to: "#testimonials",
    cta: "What colleagues say",
  },
  testimonials: {
    text: "Nine recommendations, all verbatim. Sven Krüger: 'a tangible impact on our decision-making processes.'",
    to: "#contact",
    cta: "Talk to her",
  },
  contact: {
    text: "She replies within a working day.",
    to: "#contact",
    cta: "Send a message",
  },
};

export const CONCIERGE_QUICK_PROMPTS = [
  "Why should we hire Sinthu?",
  "How does her research drive commercial decisions?",
  "Show me the food-industry case study",
  "What did she ship at the tennis club?",
];
